import React, { useEffect, useState } from 'react'
import { Layout, Spin, notification } from 'antd'
import clsx from 'clsx'
import { get, has, omit, find, isEmpty } from 'lodash'
import PerfectScrollbar from 'react-perfect-scrollbar'

import PictureWall from './PictureWall'
import { router } from '../../../system/routing'
import { withTranslation } from 'react-i18next'
import apiService from '../apiService'
import { getVar } from '../../../system/support/helpers'

const UploadProductLogoImage = ({ location, t }) => {
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        const locationQuery = router.getLocationQuery()
        const queryString = new URLSearchParams(omit(locationQuery, 'auth_token')).toString()
        router.replace(`${location.pathname}?${queryString}`)
        fetchPackageItems(locationQuery)
    }, [])

    function fetchPackageItems(params) {
        const { package_id, package_code } = params
        setLoading(true)
        apiService
            .getPackage(package_code)
            .then(res => {
                const packageInfo = getVar(res, 'data', {})
                if (isEmpty(packageInfo)) {
                    notification.error({
                        message: t('package:detail.message_cant_load_package'),
                    })
                }
                const metaData = getVar(packageInfo, 'meta_data', {})
                setData({ ...metaData, package_id: package_id })
            })
            .catch(e => {
                notification.error({
                    message: t('package:detail.message_cant_load_package'),
                })
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <Layout className={clsx('upload-damaged-images')}>
            <Spin spinning={loading}>
                <PerfectScrollbar
                    options={{
                        wheelPropagation: false,
                    }}>
                    {!isEmpty(data) && (
                        <PictureWall
                            data={data}
                            sorted
                        />
                    )}
                </PerfectScrollbar>
            </Spin>
        </Layout>
    )
}

export default withTranslation()(UploadProductLogoImage)
